export default __webpack_public_path__ + "static/media/156.ef0d25c5.png";